import { useEffect, useState } from 'react';
import type { DataTableRowEventParams as GridRowParams } from '@/components/custom/erp';
import { usePurchaseOrderStatusData } from './usePurchaseOrderStatusData';
import { orderStatusReportColumns } from '../cols-definition';
import { SearchFormValues } from '../types';

export interface UseTableDataReturn {
  tables: Array<{
    name: string;
    rows: MuaHangRecord[];
    columns: MuaHangRecord[];
  }>;
  handleRowClick: (params: GridRowParams) => void;
  isLoading: boolean;
  error: Error | null;
  refreshData: () => Promise<void>;
}

export function useTableData(searchParams: SearchFormValues = {}): UseTableDataReturn {
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const { data, isLoading, error, refreshData } = usePurchaseOrderStatusData(searchParams);

  const handleRowClick = (params: GridRowParams) => {
    const order = params.row as MuaHangRecord;
    const rowId = order?.id ?? order?.uuid ?? order?.line ?? order?.sysorder ?? null;
    setSelectedRowIndex(rowId !== null && rowId !== undefined ? String(rowId) : null);
    console.log('Row clicked:', order);
  };

  const tables = [
    {
      name: 'Báo cáo tình trạng đơn hàng mua',
      rows: data,
      columns: orderStatusReportColumns(
        () => {},
        () => {}
      )
    }
  ];

  return {
    tables,
    handleRowClick,
    isLoading,
    error,
    refreshData
  };
}
